<ion-card>
  <ion-card-header>
    <ion-card-title>BKSZ – Biztonságos Kézbesítési Szolgáltatás</ion-card-title>
    <ion-card-subtitle>
      Ezen a csatornán megy a hivatali kapu, a cégkapu és a perkapu is. A kapcsolat
      gépi: SOAP-üzenet, <b>WS-Security</b> azonosítással (rövidnév + a BEDSZ
      csatlakozáskor kapott jelszó), böngésző nélkül.
      <br><code style="font-size:.76rem">{{ hasznaltVegpont }}</code>
    </ion-card-subtitle>
  </ion-card-header>
</ion-card>

<!-- 0. küldési mód -->
<ion-card>
  <ion-card-header>
    <ion-card-title>Küldési mód</ion-card-title>
    <ion-card-subtitle>
      A BKSZ gépi végpontja <b>forrás-cím szerint</b> enged: a szolgáltatónál be kell
      jelenteni, melyik IP-ről érkezhet a kapcsolat. Ez dönti el, melyik módot kell
      választani.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <ion-radio-group [(ngModel)]="sajat.mod">
      <ion-item lines="none">
        <ion-radio slot="start" value="direkt"></ion-radio>
        <ion-label class="ion-text-wrap">
          <b>Közvetlen – erről a szerverről</b><br>
          <small>Ehhez a szervezetnek <b>állandó (statikus) IP-je</b> kell, és azt be kell
          jelenteni a szolgáltatónál. A tanúsítvány itt, ebben a rendszerben áll.</small>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-radio slot="start" value="rele"></ion-radio>
        <ion-label class="ion-text-wrap">
          <b>Központi relén keresztül</b><br>
          <small>A küldést a <b>központi szerver</b> végzi, a nála bejelentett IP-ről és a
          nála tárolt tanúsítvánnyal. Akkor kell, ha a szervezetnek nincs állandó IP-je,
          vagy ha a bejelentés eleve a központi szerverre szól. Ilyenkor a tanúsítványt
          <b>nem ide</b> kell feltölteni, hanem a relére.</small>
        </ion-label>
      </ion-item>
    </ion-radio-group>

    <div *ngIf="releMod" class="ikt-fejsor" style="margin-top:.5rem">
      <ion-input label="A relé címe" label-placement="stacked"
                 [(ngModel)]="sajat.rele_url" placeholder="https://rele.pelda.hu"></ion-input>
      <ion-input label="Telepítés-azonosító" label-placement="stacked"
                 [(ngModel)]="sajat.rele_azonosito" placeholder="pl. zenit"></ion-input>
      <ion-input label="Megosztott kulcs" label-placement="stacked" type="password"
                 [(ngModel)]="sajat.rele_kulcs"
                 [placeholder]="sajat.rele_kulcs_beallitva ? 'már be van állítva – üresen marad' : 'a relétől kapott kulcs'"></ion-input>
      <ion-button size="small" (click)="sajatMent()" [disabled]="sajatFut">
        <ion-icon slot="start" name="save-outline"></ion-icon>
        {{ sajatFut ? 'Mentés…' : 'Mentés' }}
      </ion-button>
    </div>
    <ion-note color="medium" style="font-size:.8rem" *ngIf="releMod">
      A kulcs elhagyja a képernyőt, de <b>vissza sosem jön</b>: mentés után csak az látszik,
      hogy be van állítva. Ha üresen hagyod, a korábbi kulcs marad érvényben – nem törlődik.
      Az azonosítót és a kulcsot a relé üzemeltetője adja meg (<code>node kulcs.js</code>).
    </ion-note>
    <ion-note color="medium" style="font-size:.8rem" *ngIf="!releMod">
      A lenti próba megmutatja ennek a szervernek a kimenő IP-jét – azt kell bejelenteni
      a szolgáltatónál. Ha az IP változhat, a relé a járható út.
    </ion-note>
  </ion-card-content>
</ion-card>

<!-- 1. tanúsítvány -->
<ion-card>
  <ion-card-header>
    <ion-card-title>1. {{ releMod ? 'Relé-tanúsítvány' : 'Tanúsítvány (nem kötelező)' }}</ion-card-title>
    <ion-card-subtitle *ngIf="!releMod">
      <b>A BKSZ nem kér kliens-tanúsítványt</b>: a specifikáció szerint az azonosítás
      WS-Security fejléccel történik (2. lépés). Ez a P12/PFX csak akkor kell, ha a
      hálózati út (proxy, alagút) kéri – enélkül is működik a kapcsolat. Feltöltéskor
      a jelszót is ellenőrizzük.
    </ion-card-subtitle>
    <ion-card-subtitle *ngIf="releMod">
      Relé módban <b>nem a BKSZ-tanúsítvány</b> kerül ide – az a relén van. Ez az a P12
      állomány, amivel ez a telepítés <b>azonosítja magát a relé felé</b>: a relé csak
      olyan kapcsolatot vesz fel, amelyik a te hitelesítő tanúsítványod alatt kiadott
      tanúsítványt mutatja be. Ez szűri ki a támadót – a megosztott kulcs önmagában
      kevés, mert az egyetlen titok, és ha kiszivárog, bárki küldhetne a nevünkben.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-input label="A tanúsítvány jelszava" label-placement="stacked" type="password"
                 [(ngModel)]="feltoltes.jelszo" style="max-width:240px"></ion-input>
      <input type="file" accept=".p12,.pfx" (change)="fajlValasztva($event)"
             [disabled]="feltoltesFut" style="max-width:280px" />
      <ion-spinner name="crescent" *ngIf="feltoltesFut"></ion-spinner>
    </div>

    <div class="ikt-tabla-doboz">
      <table class="ikt-tabla">
        <thead><tr><th>Állomány</th><th>Tulajdonos</th><th>Kibocsátó</th>
                   <th class="szam">Érvényes</th><th>Állapot</th></tr></thead>
        <tbody>
          <tr *ngFor="let t of tanusitvanyok">
            <td>{{ t.name }}</td>
            <td>{{ t.owner }}</td>
            <td>{{ t.issuer }}</td>
            <td class="szam">{{ t.validto | date:'yyyy-MM-dd' }}</td>
            <td>
              <ion-badge color="success" *ngIf="t.hkp">BKSZ</ion-badge>
              <ion-button size="small" fill="clear" *ngIf="!t.hkp" (click)="kijelol(t)">Kijelölés</ion-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!tanusitvanyok.length">Még nincs feltöltött tanúsítvány.</div>
    </div>
  </ion-card-content>
</ion-card>

<!-- 2. saját postafiók -->
<ion-card>
  <ion-card-header>
    <ion-card-title>2. Saját postafiók (feladó)</ion-card-title>
    <ion-card-subtitle>
      A BKSZ <b>WS-Security</b> fejléccel azonosít: a felhasználónév a hivatal
      <b>rövid neve</b>, a jelszó pedig a BEDSZ csatlakozáskor kapott jelszó. Ezt kell
      itt megadni – innentől minden lekérés és küldés ezzel a feladóval megy.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-input label="Hivatali kapu rövid neve" label-placement="stacked"
                 [(ngModel)]="sajat.rovidnev" placeholder="pl. ZENITISK"></ion-input>
      <ion-input label="KRID (ha ismert)" label-placement="stacked"
                 [(ngModel)]="sajat.krid" placeholder="11 jegyű azonosító"></ion-input>
      <ion-select label="Postafiók típusa" label-placement="stacked" interface="popover"
                  [(ngModel)]="sajat.kapu_tipus" (ngModelChange)="kapuValtozott()">
        <ion-select-option value="hivatali_kapu">hivatali kapu</ion-select-option>
        <ion-select-option value="cegkapu">cégkapu</ion-select-option>
        <ion-select-option value="perkapu">perkapu</ion-select-option>
      </ion-select>
      <ion-select label="Környezet" label-placement="stacked" interface="popover"
                  [(ngModel)]="sajat.kornyezet">
        <ion-select-option value="eles">éles</ion-select-option>
        <ion-select-option value="teszt">teszt</ion-select-option>
      </ion-select>
      <ion-button size="small" (click)="sajatMent()" [disabled]="sajatFut">
        <ion-icon slot="start" name="save-outline"></ion-icon>
        {{ sajatFut ? 'Mentés…' : 'Mentés' }}
      </ion-button>
    </div>
    <!--  MELYIK HÁLÓZATI ÚTON MEGY? Ez a CÍMET dönti el.
          A 2018 utáni csatlakozás publikus HTTPS-végpontra megy (fix IP + kliens-
          tanúsítvány). A régi, IPSec/NTG-s út saját címekkel dolgozik, amiket a
          specifikáció „megszüntetés alatt" jelöl – de akinek még az az útja, annak MA
          IS az a helyes cím, ezért választható maradt. -->
    <ion-item lines="none">
      <ion-checkbox slot="start" [checked]="sajat.ipsec"
                    (ionChange)="sajat.ipsec = $event.detail.checked"></ion-checkbox>
      <ion-label class="ion-text-wrap">
        <b>Régi, IPSec/NTG-s kapcsolat</b> (kivezetés alatt lévő címek)
        <br><small class="muted">Alapból <b>kikapcsolva</b>: a mai csatlakozás a publikus
        HTTPS-végpontra megy (hivatali kapu: <code>webservice.hkp.gov.hu</code>, teszt:
        <code>hkp-teszt.hkp.gov.hu</code>), ahhoz <b>fix kimenő IP</b> és <b>kliens-tanúsítvány</b>
        kell — NTG-s IPSec kapcsolat viszont NEM.
        <br>Csak akkor kapcsold be, ha a szervezet még a <b>régi, NTG-s úton</b> csatlakozik: akkor a
        hívás a <code>84.206.*</code> címekre megy, amiket a specifikáció „megszüntetés alatt"
        jelöléssel közöl.</small>
      </ion-label>
    </ion-item>

    <!--  KÉT AZONOSÍTÁSI ÚT VAN, ÉS EZ DÖNTI EL, MELYIK SZOLGÁLTATÁST HÍVJUK.
          A hivatalos NISZ mintakliens (iopclient 1.5.0) pontosan így dönt:
              jelszó nélkül → IOPService,  jelszóval → IOPService2 + WSS fejléc.
          A hitelesítést jelszó nélkül a HÁLÓZATI ÚT adja: kliens-tanúsítvány + fix IP,
          vagy a régi NTG/IPSec kapcsolat. Korábban ez a mód bedrótozottan az NTG-s
          IP-címre ment, ezért aki tanúsítvánnyal csatlakozott és jelszót nem kapott,
          egyik kapcsolóval sem jutott célba. -->
    <ion-item lines="none" *ngIf="hagyomanyosLehet">
      <ion-checkbox slot="start" [checked]="sajat.hagyomanyos"
                    (ionChange)="sajat.hagyomanyos = $event.detail.checked"></ion-checkbox>
      <ion-label class="ion-text-wrap">
        <b>Azonosítás jelszó nélkül</b> (hagyományos, WS-Security nélkül)
        <br><small class="muted">Akkor kell, ha a gépi interfészhez <b>nem kaptál WSS
        jelszót</b> — például mert <b>fix IP-vel és kliens-tanúsítvánnyal</b> vettek fel.
        Ilyenkor a hitelesítést a <b>hálózati út</b> adja (tanúsítvány + IP, vagy NTG/IPSec),
        a szervezetet pedig a rövid név azonosítja az üzenetben, és a hívás az
        <code>IOPService</code> szolgáltatásra megy (kettes nélkül) — <b>ugyanazon a hoszton</b>,
        amit fent a hálózati út meghatároz.
        <br><b>Tanúsítványos csatlakozásnál ezt hagyd KIKAPCSOLVA.</b> Fix IP + kliens-tanúsítvány
        esetén nem kapsz WSS jelszót, de a szolgáltatás akkor is a <code>IOPService2</code>-t
        használja, és <b>megköveteli a Security fejlécet</b> („Incoming message does not contain
        required Security header"). Ilyenkor a fejléc a <b>rövidneveddel, üres jelszóval</b> megy ki
        — a tanúsítvány hitelesíti a kapcsolatot, a fejléc pedig megmondja, melyik postafiók
        nevében küldesz. Ezt a kapcsolót csak a <b>régi, NTG-s</b> csatlakozásnál kell bekapcsolni:
        ott a hívás az <code>IOPService</code>-re megy, fejléc nélkül.
        <br>A NISZ ezt az utat <b>kivezeti</b>: „A nyílt BKSZ szolgáltatások nem lesznek
        elérhetőek a hagyományos azonosítási eljárással!" — hosszabb távon érdemes WSS
        jelszót kérni az ügyfélszolgálattól.</small>
      </ion-label>
    </ion-item>

    <div class="ikt-fejsor" *ngIf="!sajat.hagyomanyos">
      <ion-input label="WS-Security jelszó" label-placement="stacked" type="password"
                 [(ngModel)]="sajat.wss_jelszo"
                 [placeholder]="sajat.wss_jelszo_beallitva ? '•••••••• (be van állítva)' : 'a BEDSZ csatlakozáskor kapott jelszó'"></ion-input>
      <ion-note color="success" *ngIf="sajat.wss_jelszo_beallitva">A jelszó be van állítva – üresen hagyva megmarad.</ion-note>
      <ion-note color="warning" *ngIf="!sajat.wss_jelszo_beallitva && !sajat.hagyomanyos">
        Enélkül a szolgáltatás az 5-ös hibakóddal utasít el minden kérést.
      </ion-note>
    </div>
    <!--  HONNAN VAN A JELSZÓ? Ez a bevezetés leggyakoribb elakadása: nem generálható és
          nem található meg sehol egy portálon – a NISZ adja át a csatlakozáskor. -->
    <ion-note color="medium" style="font-size:.8rem; display:block" *ngIf="!sajat.hagyomanyos">
      <b>Honnan van ez a jelszó?</b> Nem generálható és nem kereshető ki sehonnan: a
      specifikáció szerint „a BEDSZ csatlakozás után a következő adatokat szolgáltatja a
      csatlakozott hivatal számára: <b>postafiók azonosító</b>, <b>WSS jelszó</b>,
      <b>KRID</b>" — ezt a hármast a <b>NISZ Ügyfélszolgálata</b> hozza a szervezet
      tudomására a regisztráció után.
      <br><b>Ha nem kaptad meg:</b> a hivatali kapu megléte önmagában nem elég ehhez a
      kapcsolathoz — a <b>gépi interfészt külön kell igényelni</b>. A webes hivatali kapu
      használatához nincs rá szükség, a gép–gép csatornához igen; ilyenkor a szolgáltatás
      a <b>41-es</b> hibakóddal felel („Nincs gépi interfésze a hivatalnak").
    </ion-note>

    <ion-input label="Gépi végpont (URL) – üresen a dokumentáció szerinti" label-placement="stacked"
               [(ngModel)]="sajat.vegpont" [placeholder]="VEGPONT"></ion-input>
    <!--  MI KELL EHHEZ A CSATLAKOZÁSHOZ? Három feltétel van, és eddig sehol nem
          látszott együtt, melyik teljesül. -->
    <div class="bksz-feltetelek">
      <div class="bksz-feltetel" *ngFor="let f of feltetelek" [class.kesz]="f.kesz">
        <ion-icon [name]="f.kesz ? 'checkmark-circle' : 'ellipse-outline'"></ion-icon>
        <div>
          <b>{{ f.cim }}</b>
          <br><small class="muted">{{ f.leiras }}</small>
        </div>
      </div>
    </div>

    <ion-note color="medium" style="font-size:.8rem">
      A hívás a <b>{{ szolgaltatasNeve }}</b> szolgáltatásra megy.
      A választott kapu és környezet szerint a cím: <b>{{ hasznaltVegpont }}</b>.
      Ezt a NISZ BKSZ Interfész Specifikáció rögzíti; a mező csak akkor kell, ha a
      szolgáltatás időközben másik címre költözött.
    </ion-note>
    <!--  A HÁLÓZATI ÚT FELTÉTELEI – a bekapcsolt IPSec szerint mások.
          A 2018 utáni (mai) csatlakozás publikus HTTPS-végpontra megy; a specifikáció
          szó szerint kimondja, hogy ahhoz NINCS szükség NTG-s IPSec kapcsolatra. A régi
          út viszont NTG-t kíván – ezért a figyelmeztetés is a választott úthoz igazodik. -->
    <ion-note color="warning" style="font-size:.8rem; display:block; margin-top:.4rem" *ngIf="ntgKell && sajat.ipsec">
      <b>Figyelem – hálózati út.</b> Bekapcsoltad a <b>régi, IPSec/NTG-s</b> kapcsolatot, ezért a
      hívás az NTG zárt hálózatán belüli IP-címre megy. Nyílt internetről, pusztán
      IP-engedélyezéssel ez a cím <b>nem nyílik meg</b> — NTG-csatlakozás (IPSec-alagút) kell hozzá.
      A specifikáció ezeket a címeket „megszüntetés alatt" jelöli.
    </ion-note>
    <ion-note color="medium" style="font-size:.8rem; display:block; margin-top:.4rem" *ngIf="ntgKell && !sajat.ipsec">
      <b>Hálózati út.</b> A mai (2018 utáni) csatlakozásnál a hivatali kapu publikus HTTPS-végpontra
      megy: <b>nincs szükség</b> NTG-n kialakított IPSec kapcsolatra. Kell viszont <b>fix kimenő IP</b>
      és <b>kliens-tanúsítvány</b> — mindkettőt a Hivatali kapu csatlakozási kérdőív alapján
      engedélyezik. Ha a szervezet még a régi, NTG-s úton csatlakozik, kapcsold be fent az
      IPSec-es kapcsolatot.
    </ion-note>

    <!--  A DOKUMENTUMTÍPUS NEM TALÁLGATHATÓ – de azt meg lehet mondani, HONNAN van.
          Ez a három érték a BKSZ-nél REGISZTRÁLT típust azonosítja; a szolgáltatás
          ismeretlen típusra elutasítja a feltöltést, és a hibaüzenetből ez nem derül ki. -->
    <ion-note color="medium" style="display:block;font-size:.78rem;margin-top:.8rem">
      <b>Mit írj ide?</b> Ezt a hármat a <b>gépi interfész igénylésekor</b> kapod meg (az IdomSoft
      SZEÜSZ ügyfélszolgálatától, a postafiók azonosítóval és a WSS jelszóval együtt) — nem
      kitalálható érték, és a szolgáltatás ismeretlen típusra <b>elutasítja</b> a feltöltést.
      A <b>hivatalazonosító</b> a szervezeté, a <b>típusazonosító</b> a dokumentumtípusé (pl. egy
      kód vagy rövid név), a <b>leírás</b> pedig szabad szöveg. Ha nem tudod, mi a tiéd, kérdezd meg
      az ügyfélszolgálatot — a NISZ mintakódja a <b>teszt</b> rendszerben mindhárom helyre
      <code>teszt</code> értéket ír.
    </ion-note>
    <div class="ikt-fejsor" style="margin-top:.8rem">
      <ion-input label="Dokumentumtípus – hivatalazonosító" label-placement="stacked"
                 [(ngModel)]="sajat.doktipus.hivatal" placeholder="pl. ZENITISK"></ion-input>
      <ion-input label="Dokumentumtípus – típusazonosító" label-placement="stacked"
                 [(ngModel)]="sajat.doktipus.azonosito" placeholder="pl. 0001"></ion-input>
      <ion-input label="Dokumentumtípus – leírás" label-placement="stacked"
                 [(ngModel)]="sajat.doktipus.leiras" placeholder="pl. Hivatalos értesítés"></ion-input>
    </div>
    <ion-note color="medium" style="font-size:.8rem">
      A dokumentumtípust a BKSZ-nél <b>regisztrálni kell</b>, és a feltöltéskor pontosan
      ezt az azonosítót várja a szolgáltatás – nem találgatható. A csatlakozási
      dokumentáció tartalmazza a szervezethez rendelt értékeket.
    </ion-note>
  </ion-card-content>
</ion-card>

<!-- 3. kapcsolat -->
<ion-card>
  <ion-card-header>
    <ion-card-title>3. Kapcsolat próbája</ion-card-title>
    <ion-card-subtitle>
      A próba a névfeloldástól a <b>valódi szolgáltatás-hívásig</b> megy: ha a hálózat
      átjár, elküld egy ártalmatlan postafiók-lekérdezést. Ez bizonyítja a WS-Security
      jelszót és a postafiók-azonosítást is – a puszta kézfogás minderről semmit nem mond.
      <span *ngIf="releMod"><br>Relé módban a próbát a <b>relé</b> futtatja: a kérdés az,
      hogy <b>az a gép</b> éri-e el a BKSZ-t, amelyik ténylegesen küld. A megjelenő
      kimenő IP is a reléé – azt kell bejelenteni a szolgáltatónál.</span>
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-button size="small" (click)="kapcsolatProba()" [disabled]="tesztFut || !probalhato">
        <ion-icon slot="start" name="pulse-outline"></ion-icon>
        {{ tesztFut ? 'Próba…' : 'Kapcsolat ellenőrzése' }}
      </ion-button>
      <ion-note color="medium" *ngIf="!sajatKesz">Előbb add meg a postafiók rövid nevét (2. lépés).</ion-note>
      <ion-note color="warning" *ngIf="sajatKesz && !wssKesz">
        Nincs WS-Security jelszó – a próba a hálózatot megméri, de az azonosítást nem tudja bizonyítani.
      </ion-note>
      <ion-note color="medium" *ngIf="releMod && !sajat.rele_url">Előbb add meg a relé címét.</ion-note>
      <ion-note color="medium" *ngIf="releMod && sajat.rele_url && !kijelolt">
        Relé módban jelölj ki egy tanúsítványt – ezzel azonosítja magát a telepítés a relé felé.
      </ion-note>
      <ion-badge color="tertiary" *ngIf="releMod">a próba a relén fut</ion-badge>
    </div>

    <div *ngIf="teszt">
      <!--  EGY MONDATOS VÁLASZ. A rétegek pontosak, de a kérdés egyszerű: „jó-e a
            végpont, vagy máshol a baj?" – ezt előre kimondjuk, hogy ne a színes
            dobozokból kelljen kikövetkeztetni. -->
      <ion-note class="ikt-kovetkeztetes" *ngIf="teszt.kovetkeztetes"
                [color]="teszt.szolgaltatas?.ok ? 'success' : 'warning'">
        <ion-icon [name]="teszt.szolgaltatas?.ok ? 'checkmark-circle-outline' : 'information-circle-outline'"></ion-icon>
        {{ teszt.kovetkeztetes }}
      </ion-note>

      <!-- Hol akadt el: a három réteg külön látszik, mert máshol javítandó mind -->
      <div class="ikt-retegek" *ngIf="teszt.lepesek">
        <div class="ikt-reteg" [class.ok]="teszt.lepesek.dns?.ok" [class.rossz]="teszt.lepesek.dns && !teszt.lepesek.dns.ok">
          <b>1. Névfeloldás</b>
          <span>{{ teszt.lepesek.dns?.ok ? teszt.lepesek.dns.ip : (teszt.lepesek.dns?.hiba || '–') }}</span>
        </div>
        <div class="ikt-reteg" [class.ok]="teszt.lepesek.tcp?.ok" [class.rossz]="teszt.lepesek.tcp && !teszt.lepesek.tcp.ok">
          <b>2. Kapcsolat</b>
          <span>{{ teszt.lepesek.tcp ? (teszt.lepesek.tcp.ok ? 'létrejött' : teszt.lepesek.tcp.hiba) : 'nem futott' }}</span>
        </div>
        <!--  A hivatali kapu végpontja sima HTTP: ott nincs kézfogás, és ez nem hiba.
              Ilyenkor a réteg semlegesen jelenik meg, nem pirosan. -->
        <div class="ikt-reteg" [class.ok]="teszt.kapcsolat?.ok === true"
             [class.rossz]="teszt.kapcsolat?.ok === false && teszt.lepesek.tcp?.ok">
          <b>3. TLS-kézfogás</b>
          <span>{{ teszt.kapcsolat?.nem_ertelmezett ? 'nincs (HTTP-végpont)'
                 : (teszt.kapcsolat?.ok ? teszt.kapcsolat.protokoll
                 : (teszt.lepesek.tcp?.ok ? 'elutasítva' : 'idáig nem jutott')) }}</span>
        </div>
        <!--  A 4. réteg a lényeg: ez az egyetlen, ami a WS-Security jelszót és a
              postafiók-azonosítást is bizonyítja. -->
        <div class="ikt-reteg" [class.ok]="teszt.szolgaltatas?.ok"
             [class.rossz]="teszt.szolgaltatas && !teszt.szolgaltatas.ok">
          <b>4. Szolgáltatás</b>
          <span>{{ !teszt.szolgaltatas ? 'nem futott'
                 : (teszt.szolgaltatas.ok ? 'válaszolt'
                 : (teszt.szolgaltatas.kihagyva ? 'kihagyva'
                 : (teszt.szolgaltatas.hiba?.kod ? (teszt.szolgaltatas.hiba.kod + '-es hiba') : 'elutasítva'))) }}</span>
        </div>
        <!-- Kontroll: csak akkor mérjük, ha a végpont néma – ez dönti el, kinél a hiba -->
        <div class="ikt-reteg" *ngIf="teszt.lepesek.kontroll"
             [class.ok]="teszt.lepesek.kontroll.ok" [class.rossz]="!teszt.lepesek.kontroll.ok">
          <b>Kontroll: {{ teszt.lepesek.kontroll.gazdagep }}</b>
          <span>{{ teszt.lepesek.kontroll.ok ? 'elérhető' : teszt.lepesek.kontroll.hiba }}</span>
        </div>
      </div>

      <div class="ikt-diagnozis" *ngIf="teszt.kapcsolat?.magyarazat"
           [class.szolgaltato]="teszt.kapcsolat.ertelmezes === 'a_szolgaltatonal'"
           [class.halozat]="teszt.kapcsolat.ertelmezes === 'halozat'">
        <b>{{ diagnozisCim(teszt.kapcsolat.ertelmezes) }}</b>
        <div>{{ teszt.kapcsolat.magyarazat }}</div>
        <div *ngIf="teszt.kimeno_ip" class="ip">
          {{ teszt.mod === 'rele' ? 'A RELÉ kimenő IP-címe' : 'A szerver kimenő IP-címe' }}:
          <b>{{ teszt.kimeno_ip }}</b>
          <ion-button size="small" fill="clear" (click)="masol(teszt.kimeno_ip)">másolás</ion-button>
        </div>
      </div>

      <!--  A VALÓDI HÍVÁS. A hibakódot magyarul is kiírjuk: az 5-ös a jelszót, a
            103-as a rövidnév/KRID párost cáfolja – két teljesen más javítás. -->
      <div class="ikt-diagnozis" *ngIf="teszt.szolgaltatas?.hiba">
        <b>A szolgáltatás elutasította a kérést{{ teszt.szolgaltatas.hiba.kod ? ' (' + teszt.szolgaltatas.hiba.kod + ')' : '' }}</b>
        <div *ngIf="teszt.szolgaltatas.hiba.szoveg">{{ teszt.szolgaltatas.hiba.szoveg }}</div>
        <div *ngIf="teszt.szolgaltatas.hiba.magyarazat"><b>{{ teszt.szolgaltatas.hiba.magyarazat }}</b></div>
      </div>
      <div class="ikt-diagnozis" *ngIf="teszt.szolgaltatas?.ok">
        <b>A szolgáltatás válaszolt</b>
        <div>
          A postafiók elérhető, az azonosítás működik.
          <span *ngIf="teszt.szolgaltatas.olvasatlan_uzenetek != null">
            Olvasatlan üzenetek: <b>{{ teszt.szolgaltatas.olvasatlan_uzenetek }}</b>.
          </span>
        </div>
      </div>

      <div class="ikt-diagnozis" *ngIf="teszt.sajat_postafiok && !teszt.sajat_postafiok.feladoAzonosito">
        <b>Nincs megadva a saját postafiók</b>
        <div>
          A kapcsolat próbáján ez nem látszik, a küldésnél viszont elakad: töltsd ki
          fent a 2. lépést (hivatali kapu rövid neve / KRID).
        </div>
      </div>

      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <tbody>
            <tr *ngIf="teszt.hiba"><th>Hiba</th><td colspan="3">{{ teszt.hiba }}</td></tr>
            <tr *ngIf="teszt.tanusitvany">
              <th>Tanúsítvány</th><td>{{ teszt.tanusitvany.tulajdonos }}</td>
              <th>Érvényes</th>
              <td class="szam">
                {{ teszt.tanusitvany.ervenyes_ig | date:'yyyy-MM-dd' }}
                <ion-badge color="danger" *ngIf="teszt.tanusitvany.lejart">lejárt</ion-badge>
              </td>
            </tr>
            <tr *ngIf="teszt.tanusitvany?.felbontas_mod">
              <th>Felbontás módja</th><td>{{ teszt.tanusitvany.felbontas_mod }}</td>
              <th>Ügyfél-hitelesítésre</th>
              <td>
                <ion-badge [color]="teszt.tanusitvany.alkalmas_tls_re ? 'success' : 'warning'">
                  {{ teszt.tanusitvany.alkalmas_tls_re ? 'alkalmas' : 'nem alkalmas' }}
                </ion-badge>
              </td>
            </tr>
            <tr *ngIf="teszt.tanusitvany?.figyelmeztetes">
              <th>Figyelmeztetés</th>
              <td colspan="3" style="color:var(--ion-color-warning-shade,#a06a00)">
                {{ teszt.tanusitvany.figyelmeztetes }}
              </td>
            </tr>
            <tr><th>Végpont</th><td colspan="3" style="font-size:.76rem">{{ teszt.vegpont }}</td></tr>
            <tr *ngIf="teszt.kapcsolat?.ok">
              <th>Kiszolgáló</th><td>{{ teszt.kapcsolat.kiszolgalo }}</td>
              <th>Saját tanúsítvány küldve</th>
              <td>{{ teszt.kapcsolat.sajat_tanusitvany_kuldve ? 'igen' : 'nem' }}</td>
            </tr>
            <tr *ngIf="teszt.kapcsolat && !teszt.kapcsolat.ok">
              <th>Nyers hibakód</th>
              <td colspan="3">{{ teszt.kapcsolat.kod }} {{ teszt.kapcsolat.hiba }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ion-card-content>
</ion-card>

<!--  A LETÖLTÖTT TÉTELEK LISTÁJA ÁTKÖLTÖZÖTT. Ez a képernyő a kapcsolat beállítása (egyszer),
      a postafiókot viszont naponta nézik – ezért saját menüpontot kapott. -->
<ion-card>
  <ion-card-header>
    <ion-card-title>Beérkezett küldemények és igazolások</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <p style="font-size:.88rem; margin:0 0 10px">
      A letöltött tételek listája, a keresés, az érkeztetés és az iktatás a saját menüpontjában van:
      <b>Iktatás → Beérkezett küldemények</b>. Az ütemezés (automatikus letöltés, gyakoriság) is ott állítható.
    </p>
    <ion-button size="small" routerLink="/iktatgato/kuldemenyek">
      <ion-icon slot="start" name="mail-unread-outline"></ion-icon>Beérkezett küldemények
    </ion-button>
  </ion-card-content>
</ion-card>

<!-- 4/b. dolgozók kapcsolati kódjai -->
<ion-card>
  <ion-card-header>
    <ion-card-title>Kapcsolati kódok – dolgozók</ion-card-title>
    <ion-card-subtitle>
      Természetes személynek a hivatali kapun <b>kapcsolati kóddal</b> lehet küldeni. Enélkül a
      bérjegyzék-kiküldés személyenként akad el — itt egy helyen látszik, kinél van meg.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-button size="small" fill="outline" (click)="dolgozoKodokBetolt()" [disabled]="kodokFut">
        <ion-icon slot="start" name="refresh-outline"></ion-icon>
        {{ kodokFut ? 'Dolgozik…' : 'Lista betöltése' }}
      </ion-button>
      <ion-button size="small" (click)="kodLekerMind()" [disabled]="kodokFut || !dolgozoKodok.length || !sajatKesz">
        <ion-icon slot="start" name="key-outline"></ion-icon>Lekérés mindenkinél, akinél hiányzik
      </ion-button>
      <ion-note color="medium" *ngIf="dolgozoKodok.length" style="font-size:.8rem">
        {{ dolgozoKodok.length }} dolgozó, ebből <b>{{ kodHiany }}</b> kód nélkül.
      </ion-note>
    </div>

    <ion-note color="medium" style="display:block;font-size:.78rem;margin:8px 0">
      A lekérés nem mindig jár sikerrel: a szolgáltatás csak azt találja meg, aki <b>regisztrált a
      tárhelyre</b>, és az azonosító adatoknak pontosan egyezniük kell. Ezért a kód <b>kézzel is
      beírható</b> — aki máshonnan megkapta, itt rögzítheti. Az üres mező mentése törli a kódot.
    </ion-note>

    <div class="ikt-tabla-doboz" *ngIf="dolgozoKodok.length">
      <table class="ikt-tabla">
        <thead>
          <tr><th>Dolgozó</th><th>Kapcsolati kód</th><th></th><th>Állapot</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of dolgozoKodok">
            <td>
              {{ p.nev }}
              <div class="kod-hiany" *ngIf="p.hiany?.length">hiányzik: {{ p.hiany.join(', ') }}</div>
            </td>
            <td><ion-input [(ngModel)]="p.uj_kod" placeholder="nincs" class="kod-mezo"></ion-input></td>
            <td class="kod-gombok">
              <ion-button size="small" fill="clear" (click)="kodLekerEgy(p)"
                          [disabled]="kodSorFut === p.id || !sajatKesz || p.hiany?.length">
                {{ kodSorFut === p.id ? '…' : 'Lekérés' }}
              </ion-button>
              <ion-button size="small" fill="clear" color="success" (click)="kodMentEgy(p)"
                          [disabled]="p.uj_kod === (p.kapcsolati_kod || '')">Mentés</ion-button>
            </td>
            <td class="kod-uzenet">{{ p.uzenet }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ikt-ures" *ngIf="!kodokFut && !dolgozoKodok.length">
      Töltsd be a listát a fenti gombbal. A dolgozók a partnertörzsből jönnek — ha üres, előbb
      az Iktatgató partnertörzsébe kell átvenni az állományt.
    </div>
  </ion-card-content>
</ion-card>

<!-- 4. kapcsolati kód -->
<ion-card>
  <ion-card-header>
    <ion-card-title>4. Kapcsolati kód lekérése</ion-card-title>
    <ion-card-subtitle>
      A BKSZ nem a néven, hanem a kapcsolati kódon címez. A kód a természetes
      azonosítókból kérhető le – ezért figyelmeztet a partnertörzs, ha valakinél
      hiányzik a születési név, az anyja neve vagy a születési hely/idő.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-input label="Feladó (a 2. lépésből)" label-placement="stacked" [(ngModel)]="kapcsolat.kuldo_rovidnev"
                 placeholder="rövid név vagy KRID"></ion-input>
      <ion-select label="Partner a törzsből" label-placement="stacked" interface="popover"
                  [(ngModel)]="kapcsolat.partner_id" (ionChange)="partnerValt()">
        <ion-select-option value="">– kézi megadás –</ion-select-option>
        <ion-select-option *ngFor="let p of partnerek" [value]="p.id">{{ p.nev }}</ion-select-option>
      </ion-select>
    </div>

    <div class="ikt-fejsor">
      <ion-input label="Viselt név" label-placement="stacked" [(ngModel)]="szemely.nev"></ion-input>
      <ion-input label="Születési név" label-placement="stacked" [(ngModel)]="szemely.szuletesi_nev"></ion-input>
      <ion-input label="Anyja neve" label-placement="stacked" [(ngModel)]="szemely.anyja_neve"></ion-input>
      <ion-input label="Születési hely" label-placement="stacked" [(ngModel)]="szemely.szul_hely"></ion-input>
      <ion-input label="Születési idő" label-placement="stacked" type="date" [(ngModel)]="szemely.szul_ido"></ion-input>
      <ion-button size="small" (click)="kapcsolatiKod()" [disabled]="kodFut || !sajatKesz">
        <ion-icon slot="start" name="key-outline"></ion-icon>
        {{ kodFut ? 'Lekérés…' : 'Kapcsolati kód' }}
      </ion-button>
    </div>

    <div *ngIf="kodEredmeny" style="margin-top:10px">
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <tbody>
            <tr *ngIf="kodEredmeny.kapcsolati_kod">
              <th>Kapcsolati kód</th>
              <td><b class="iktszam">{{ kodEredmeny.kapcsolati_kod }}</b></td>
            </tr>
            <!--  MELYIK ÚTON JÖTT A VÁLASZ. Jelszó nélkül IOPService, jelszóval
                  IOPService2 – de nem biztos, hogy mindkettő él ezen a hoszton. Ha az
                  első próba nem ad kódot, a rendszer a másikat is megpróbálja, és itt
                  látszik, melyik mit felelt. Ebből derül ki, hogy a szolgáltatás
                  utasított-e el, vagy az a szolgáltatás azon a címen nincs is. -->
            <tr *ngIf="kodEredmeny.probak?.length > 1 || kodEredmeny.hasznalt_url">
              <th>Próbált utak</th>
              <td>
                <div *ngFor="let pr of kodEredmeny.probak" class="kod-proba">
                  <b>{{ pr.kod ? '✔' : '✘' }}</b>
                  {{ pr.url }}
                  <span *ngIf="pr.http"> · HTTP {{ pr.http }}</span>
                  <span *ngIf="pr.hiba"> · {{ pr.hiba }}</span>
                  <span *ngIf="pr.hiba_szoveg"> – {{ pr.hiba_szoveg }}</span>
                </div>
              </td>
            </tr>
            <!--  A szolgáltatás a nevet és az e-mailt is visszaadja: ez az egyetlen
                  ellenőrzés arra, hogy tényleg a keresett személyt találtuk meg. -->
            <tr *ngIf="kodEredmeny.talalt_nev">
              <th>Megtalált név</th><td>{{ kodEredmeny.talalt_nev }}</td>
            </tr>
            <tr *ngIf="kodEredmeny.talalt_email">
              <th>E-mail</th><td>{{ kodEredmeny.talalt_email }}</td>
            </tr>
            <tr *ngIf="kodEredmeny.hiba">
              <th>Hiba</th>
              <td>
                {{ kodEredmeny.hiba.kod }} – {{ kodEredmeny.hiba.szoveg }}
                <div *ngIf="kodEredmeny.hiba.magyarazat"><b>{{ kodEredmeny.hiba.magyarazat }}</b></div>
              </td>
            </tr>
            <tr *ngIf="kodEredmeny.hiba_szoveg">
              <th>Hiba</th><td>{{ kodEredmeny.hiba_szoveg }}</td>
            </tr>
            <tr *ngIf="kodEredmeny.felado">
              <th>Feladó</th><td>{{ kodEredmeny.felado }}</td>
            </tr>
            <tr *ngIf="kodEredmeny.http_statusz">
              <th>HTTP</th><td>{{ kodEredmeny.http_statusz }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <details style="margin-top:8px" *ngIf="kodEredmeny.nyers_valasz || kodEredmeny.elkuldott_keres">
        <summary style="cursor:pointer;font-size:.85rem">Nyers üzenetek (a séma hangolásához)</summary>
        <div *ngIf="kodEredmeny.elkuldott_keres">
          <b style="font-size:.8rem">Elküldött kérés</b>
          <pre class="ikt-xml">{{ kodEredmeny.elkuldott_keres }}</pre>
        </div>
        <div *ngIf="kodEredmeny.nyers_valasz">
          <b style="font-size:.8rem">Válasz</b>
          <pre class="ikt-xml">{{ kodEredmeny.nyers_valasz }}</pre>
        </div>
      </details>
    </div>
  </ion-card-content>
</ion-card>

<!-- nyers üzenet -->
<ion-card>
  <ion-card-header>
    <ion-card-title>
      Nyers KR-üzenet
      <ion-button size="small" fill="clear" (click)="nyersNyitva = !nyersNyitva">
        {{ nyersNyitva ? 'elrejt' : 'megnyit' }}
      </ion-button>
    </ion-card-title>
    <ion-card-subtitle *ngIf="nyersNyitva">
      Ha a kapcsolati kód sémája eltér a dokumentációtól, ide beillesztheted a pontos
      XML-t, és azonnal látod a választ – nem kell kódot módosítani minden próbához.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content *ngIf="nyersNyitva">
    <div class="ikt-fejsor">
      <ion-input label="SOAPAction" label-placement="stacked" [(ngModel)]="nyers.soap_action"></ion-input>
      <ion-button size="small" (click)="nyersKuldes()" [disabled]="nyersFut || !kijelolt">
        {{ nyersFut ? 'Küldés…' : 'Küldés' }}
      </ion-button>
    </div>
    <ion-textarea label="XML" label-placement="stacked" [autoGrow]="true" rows="8"
                  [(ngModel)]="nyers.xml" style="font-family:monospace;font-size:.8rem"></ion-textarea>
    <div *ngIf="nyersEredmeny">
      <b style="font-size:.8rem">Válasz ({{ nyersEredmeny.http_statusz || '–' }})</b>
      <pre class="ikt-xml">{{ nyersEredmeny.nyers_valasz || nyersEredmeny.error }}</pre>
    </div>
  </ion-card-content>
</ion-card>
